import FlyoutItem from './flyout-item';
import FlyoutDivider from './flyout-divider';
import PopoutContainer from '../popout/popout-container';

const FlyoutMenuItem = () => {
  console.warn('<FlyoutMenuItem> is deprecated. Please change to <FlyoutItem>');
  return FlyoutItem;
};

const FlyoutMenuDivider = () => {
  console.warn('<FlyoutMenuDivider> is deprecated. Please change to <FlyoutDivider>');
  return FlyoutDivider;
};

const FlyoutMenu = () => {
  console.warn('<FlyoutMenu> is deprecated. Please change to <PopoutContainer>');
  return PopoutContainer;
};

export { default as Flyout } from './flyout';
export { FlyoutItem, FlyoutDivider, FlyoutMenuItem, FlyoutMenuDivider, FlyoutMenu };
